export const tokens = {
  navy: {
    950: "#161822",
    900: "#1E2130",
    800: "#252A3A",
    700: "#2E3448",
    600: "#3A4158",
  },
  accent: {
    main: "#DB9626",
    hover: "#C4841F",
    muted: "rgba(219, 150, 38, 0.16)",
    soft: "#F2D4A7",
  },
  text: {
    primary: "#F5F6F8",
    secondary: "#9CA3B4",
    disabled: "#6B7280",
    onAccent: "#1E2130",
  },
  semantic: {
    success: "#07BB4F",
    error: "#EC2D30",
    info: "#2D7BEF",
  },
  caliber: {
    sover: "#FCCE27",
    siyay: "#6FBDC9",
    voshod: "#6591CE",
  },
  border: "rgba(255, 255, 255, 0.08)",
  sidebar: {
    expanded: 264,
    collapsed: 80,
  },
  header: {
    height: 64,
  },
} as const;
